import Solutions from '../Solutions';
import Filters from './../Filters';

import { useAppSelector } from '../../app/hooks';
import './Home.scss';
import { LoadingIndicator } from '@festo-ui/react';

const Home = (): JSX.Element => {
  const isLoading = useAppSelector((state) => state.filter.isFiltersLoading);

  if (isLoading === 'pending' || isLoading === 'idle') {
    return <LoadingIndicator size="medium" />;
  }

  if (isLoading === 'error') {
    return <h1>Fetching error...</h1>;
  }

  return (
    <div className="container-body container-fluid ">
      <section className="fwe-mb-6">
        <div className="main-section">
          <Filters />
          <Solutions />
        </div>
      </section>
    </div>
  );
};

export default Home;
